export default "__VITE_PUBLIC_ASSET__82e4fad7__"